import React from "react";
import Dropdown from "components/atoms/Dropdown/Dropdown";

interface ContainerTypeFieldProps {
  options: any[];
}

function ContainerTypeField({ options }: ContainerTypeFieldProps) {
  return (
    <div className="dropdown-div packing-list-add-item-input-large" style={{ marginTop: 23 }}>
      <Dropdown
        useHookForm
        shouldUnregister
        name="container_type"
        className="schedule-dropdown"
        defaultValue={options[0]?.value}
        options={options}
      />
    </div>
  );
}

export default ContainerTypeField;
